import jwt_decode from 'jwt-decode';

/**
 * Return authentication status from stored token or Keycloak values
 *
 * @param keycloakToken
 * @param keycloakAuthenticated
 * @param timeSkew seconds the browser clock is ahead of the server, as measured by keycloak-js
 * @return {boolean}
 */
export const checkAuthentication = (keycloakToken, keycloakAuthenticated, timeSkew = 0) => {
    let keycloakTokenExists = (keycloakToken !== undefined && keycloakToken !== null);

    // Check that Keycloak has an authenticated value and a token value:
    if (keycloakTokenExists && keycloakAuthenticated !== undefined) {
        if (tokenIsExpired(keycloakToken, timeSkew)) {
            return false;
        }

        // Return Keycloak's authenticated value
        return (keycloakAuthenticated);
    }

    return false;
};

/**
 * Determine if a token is expired from its exp value.
 *
 * The exp claim is server time. The browser clock can differ from it, so the
 * comparison applies the skew keycloak-js measured when it received the token,
 * using the same formula as keycloak.isTokenExpired(). Without the correction a
 * clock ahead of the server by at least the token lifetime treats every token
 * as expired the moment it arrives.
 *
 * @param token
 * @param timeSkew seconds the browser clock is ahead of the server (keycloak-js timeSkew)
 */
export const tokenIsExpired = (token, timeSkew = 0) => {
    let isExpired = false;
    const tokenValue = (token !== null) ? token : null;
    if (tokenValue) {
        // Decode the token and extract its expiration timestamp
        const decodedToken = jwt_decode(tokenValue);
        const tokenExp = decodedToken.exp;
        const skew = Number.isFinite(timeSkew) ? timeSkew : 0;

        const nowSeconds = Math.ceil(Date.now() / 1000);
        isExpired = ((tokenExp - nowSeconds + skew) <= 0);
    }
    return isExpired;
};

/**
 * Determine if user has role
 *
 * @param token
 * @param type
 * @param role
 * @return {boolean}
 */
export const hasRole = (token, type, role) => {
    const tokenValue = (token !== null) ? token : null;
    if (tokenValue) {
        const decodedToken = jwt_decode(tokenValue);
        let roles;
        let idx;
        if (type === 'realm') {
            roles = decodedToken.realm_access.roles;
        }
        if (type === 'resource') {
            roles = decodedToken.resource_access.account.roles;
        }
        idx = roles.findIndex(r => r === role);
        if (idx !== -1) {
            return true;
        }
    }
    return false;
};
